import { useCallback } from 'react';
import { Flex, Box, IconBenefitsCard, IconArrow, GlobalIcons } from '@creditas-ui/react';
import { Card, CardHeader } from '@/components/Card';
import { useWindowResize } from '@/hooks/helpers/useWindowResize';
import { dispatchDiscoveryAtworkEvent } from '@/utils/analyticsEvents';
import { openFlows } from '@/utils/flows';
import { redirectToPayroll } from '@/utils/redirect';
import i18n from '@/i18n';
import { Title, Description, CardContent, Icon } from './Card.style';
import { HasCompact } from './types';

const TextContentAtWorkCard = (): JSX.Element => (
  <>
    <Title color="neutral.90" variant="bodyLgMedium">
      {i18n.t('benefitsSection:cards.at_work.title')}
    </Title>
    <Description color="neutral.60" variant="bodySmRegular">
      {i18n.t('benefitsSection:cards.at_work.description')}
    </Description>
  </>
);

type AtWorkCardProps = HasCompact;

const AtWorkCard = ({ compact = false }: AtWorkCardProps): JSX.Element => {
  const { isMobile } = useWindowResize();

  const dispatchEventAndRedirect = useCallback((): void => {
    redirectToPayroll();
    dispatchDiscoveryAtworkEvent();
  }, []);

  const handleClick = useCallback((): void => {
    openFlows(dispatchEventAndRedirect);
  }, [dispatchEventAndRedirect]);

  return (
    <Card
      onClick={(): void => handleClick()}
      gridColumn={{ _: '1/2', '5xl': compact ? '1/2' : '1/3' }}
    >
      {isMobile || compact ? (
        <>
          <CardHeader>
            <Icon>
              <GlobalIcons Icon={IconBenefitsCard} size="large" />
            </Icon>
            <GlobalIcons Icon={IconArrow} size="large" />
          </CardHeader>

          <CardContent marginTop="0" marginRight="20px">
            <TextContentAtWorkCard />
          </CardContent>
        </>
      ) : (
        <CardContent marginTop="0">
          <Flex alignItems="center">
            <Icon>
              <GlobalIcons Icon={IconBenefitsCard} size="large" />
            </Icon>
            <Box flex="1 1 auto">
              <TextContentAtWorkCard />
            </Box>
            <GlobalIcons Icon={IconArrow} size="medium" alignSelf="flex-start" />
          </Flex>
        </CardContent>
      )}
    </Card>
  );
};

export { AtWorkCard };
